import type { IMasterDataDeductionCategoryRepository } from "@src/domain/repositories/masterData";
import type { GetMasterDataDeductionCategoriesDTO } from "@src/domain/dto/masterData";

export class GetMasterDataDeductionCategoriesUseCase {
  private readonly repository: IMasterDataDeductionCategoryRepository;

  constructor(repository: IMasterDataDeductionCategoryRepository) {
    this.repository = repository;
  }

  execute(params: GetMasterDataDeductionCategoriesDTO) {
    return this.repository.getDeductionCategories(params);
  }
}
